import { toArray } from '@portal-internet/core';

import Enllac from 'components/3catinfo/Enllac/';
import styles from './llistatTemes.module.scss';

const LlistatTags = (props) => {
    const { items, lletra } = props;

    return (
        <div className={styles.llistatTagsLletra}>
            <span className={styles.anchorLletra} id={lletra.toLowerCase()} />
            <h2 className={styles.titolLletra}>{lletra}</h2>

            <ul className={styles.temesLletra}>
                {toArray(items).map(({ attributes, url }, index) => (
                    <li key={`llistat-temes-lletra-tag-${attributes.titolbonic}-${index}`}>
                        <Enllac
                            type='web_actualitat_seccio'
                            slug={attributes.titolbonic}
                            className={styles.tag}
                            title={`Totes les notícies de: ${attributes.nom}`}
                            redirect={true}
                        >
                            {attributes.nom}
                        </Enllac>
                    </li>
                ))}
            </ul>
        </div>
    );
};

const Llistat = (props) => {
    const { items } = props;

    return (
        <div className={styles.contentTemes}>
            {toArray(items).map(({ attributes, category }, index) => (
                <LlistatTags
                    key={`block-llistat-temes-lletra-${attributes.valor}-${index}`}
                    lletra={attributes.valor}
                    items={category}
                />
            ))}
        </div>
    );
};

const LlistatTemes = (props) => {
    const { items } = props;

    return (
        <>
            <Llistat items={items} />
        </>
    );
};

export default LlistatTemes;
